import {
  Headline,
  MainContent,
  VideoHeader,
} from "../templates/common/Components.jsx";

import Container from "../templates/common/Container.jsx";
import LoggedInTemplate from "../templates/LoggedInTemplate.jsx";
import videoPlaceholder from "../img/daikin_placeholder_video@2x.png";

export default function TrainingTutorial() {
  return (
    <LoggedInTemplate title="Programme">
      <VideoHeader video="/files/tuto_formation.mp4" image={videoPlaceholder} />
      <MainContent>
        <Headline title="Découvrez votre nouvel Espace Formation" big>
          Développez vos connaissances et vos compétences grâce aux formations
          Daikin.
          <br />
          Retrouvez dans la vidéo ci-dessus toutes les étapes pour vous
          connecter à l'Espace Formation Docebo, inscrire vos collaborateurs à
          une session de formation et profiter de votre budget dédié.
          <br />
          <br />
          En cas de question, contactez-nous <br />
          Téléphone : <a href="tel:+33337722204">03 37 72 22 04</a> (+ taper 4)
          <br />
          Email :{" "}
          <a href="mailto:serviceformations@daikin.fr">
            serviceformations@daikin.fr
          </a>
          <br />
        </Headline>
        <Container></Container>
      </MainContent>
    </LoggedInTemplate>
  );
}
